// mobile-menu
import './js/mobile-menu.js';
// gallery Script
import './js/gallery.slider.js';
// Customer reviews slider-slick
import './js/slick.js';
import './js/reviews.slick.js';
//Modal Read more
import './js/read-more.js';
// modal ingredients
import './js/modal-ingredients.js';
// modal franchise
import './js/modal-franchise.js';
// modal location
import './js/modal-location.js';
//  modal buy
import './js/buy.js';
//  scroll up button
import './js/scroll-top-btn.js';
//hero animation
import './js/hero.js';
